module.exports = __webpack_public_path__ + "img/22345.90d5aa8d.png";